import React from "react";
import {
  Autocomplete,
  TextField,
  Chip,
  FormControl,
} from "@mui/material";

// Always return array from normalizeValue
const normalizeValue = (val) => {
  if (Array.isArray(val)) return val;
  if (typeof val === "string" && val.trim() !== "") return [val];
  return [];
};

const MultiSelectSearchDropdownWidget = ({
  id,
  label,
  options,
  value,
  required,
  disabled,
  readonly,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  rawErrors = [],
}) => {
  // Get multiple from ui:options (RJSF passes inside options)
  const { enumOptions = [], enumDisabled = [], multiple = true } = options?.uiOptions || options;
  const normalizedValue = normalizeValue(value);

  // Build Autocomplete options
  const autocompleteOptions = enumOptions.map((opt) => ({
    label: opt.label,
    value: opt.value,
    disabled: enumDisabled.includes(opt.value),
  }));

  // Selected values
  const selectedOptions = multiple
    ? autocompleteOptions.filter((opt) => normalizedValue.includes(opt.value))
    : autocompleteOptions.find((opt) => opt.value === normalizedValue[0]) || null;

  // Handle change
  const handleChange = (_, newValue) => {
    if (multiple) {
      onChange(newValue.map((item) => item.value));
    } else {
      onChange(newValue ? [newValue.value] : []); // always store as array
    }
  };

  return (
    <FormControl
      fullWidth
      error={rawErrors.length > 0}
      disabled={disabled || readonly}
    >
      <Autocomplete
        multiple={multiple}
        id={id}
        options={autocompleteOptions}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, val) => option.value === val.value}
        value={selectedOptions}
        onChange={handleChange}
        disabled={disabled || readonly}
        onBlur={onBlur && (() => onBlur(id, value))}
        onFocus={onFocus && (() => onFocus(id, value))}
        filterSelectedOptions
        renderTags={
          multiple
            ? (tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    label={option.label}
                    {...getTagProps({ index })}
                    key={option.value}
                  />
                ))
            : undefined
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            placeholder={placeholder || (multiple ? "Select options..." : "Select option...")}
          />
        )}
      />
    </FormControl>
  );
};

export default MultiSelectSearchDropdownWidget;
